<template>
  <div :class="$b({ sticky })">
    <div
      v-for="button in buttons"
      :key="button.id"
      :class="$b('button-container')"
    >
      <BaseButton
        v-if="button.__typename === 'InlineCtaRecord'"
        :outline="true"
        :to="button.target"
        size="x-small"
        background-colour="black"
      >
        <template #content>
          {{ button.copy }}
        </template>
      </BaseButton>
      <PrimaryLineLink
        v-else
        :class="$b('button')"
        is-button
        :to="button.sectionId"
        @click="handleClick(button.sectionId)"
      >
        {{ button.buttonText }}
      </PrimaryLineLink>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AnchorButtonRow',

  props: {
    buttons: {
      type: Array,
      default: () => []
    },
    sticky: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    handleClick (location) {
      this.$scrollTo(`${location}`)
    }
  }
}
</script>

<style lang="postcss">
.AnchorButtonRow {
  @apply flex flex-wrap items-center justify-center
    w-full mx-auto gap-x-4 gap-y-8 sm:gap-x-20;
}

.AnchorButtonRow__button {
  @apply text-base sm:text-lg font-bold py-2;
}

/**
  Modifiers
  --sticky
*/
.AnchorButtonRow--sticky {
  @apply block w-fit py-4 px-[var(--outer-gutter)]
  mx-auto max-w-screen-full overflow-auto whitespace-nowrap;

  &::-webkit-scrollbar {
    display: none;
  }

  &::before, &::after {
    @apply content-[''] absolute pointer-events-none
    w-[var(--outer-gutter)] h-full top-0 z-10;
    background: linear-gradient(to right, rgba(255,255,255,1), rgba(255,255,255,0))
  }

  &::before {
    @apply left-0;
  }

  &::after {
    @apply right-0 rotate-180;
  }

  .AnchorButtonRow__button-container {
    @apply inline-block ml-4 sm:ml-8;

    &:first-child {
      @apply ml-0;
    }
  }
}
</style>
